import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryStringCaseInsensitive from "@insite/client-framework/Common/Utilities/parseQueryStringCaseInsensitive";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EditAccessorialsForm from "@tKgpco/Components/Accessorials/EditAccessorialsForm";
import loadAccessorial from "@tKgpco/Handlers/Accessorials/LoadAccessorial";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    loadAccessorial,
};

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    let accessorialId;
    if (location && location.search) {
        const parsedQuery = parseQueryStringCaseInsensitive(location.search, {
            accessorialId: "",
        });
        accessorialId = parsedQuery.accessorialId;
    }
    return {
        isLoading: state.KGPState.customEditAccessorial.isLoading,
        accessorialId,
        accessorial: state.KGPState.customEditAccessorial.accessorial,
    };
};

interface CustomWidgetStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

const styles: CustomWidgetStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const EditAccessorialsPage: React.FC<Props> = ({ id, loadAccessorial, accessorial, accessorialId, isLoading }) => {
    useEffect(() => {
        if (!isLoading && accessorialId) {
            loadAccessorial({ id: accessorialId });
        }
    }, [accessorialId]);
    if (isLoading) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        );
    }

    if (!accessorial) {
        return null;
    }

    return <EditAccessorialsForm accessorial={accessorial} />;
};

const editAccessorialsPage: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(EditAccessorialsPage),
    definition: {
        group: "Basic",
    },
};

export default editAccessorialsPage;
